import PageCommon from "../../PageCommon.js";
import PageDetail from "../../abstract/PageDetail.js";

export default class PageDeliveryDetail extends PageDetail {
    constructor() {
        super();

        this.fieldErrors = new Set();
    }

    init($data) {
        super.init($data);
        const initialUpdatedState = this.updated;
        this.DEFAULT_SLA_ISOLA = 25;            // sono i giorni di consegna previsti per le isole
        this.DEFAULT_SLA_PENISOLA = 15;         // sono i giorni di consegna previsti per la penisola
        this.DEFAULT_SLA_INSTALLATION = 5;      // sono i giorni di installazione previsti per la BB
        this.DEFAULT_SLA_REPAIR = 30;          // sono i giorni di riparazione previsti per i danni


        this.initEventHandlers();
        this.performInitialCalculations();
        this.performConstrains();
        this.updated = initialUpdatedState;
        if (!this.updated) {
            PageCommon.disable($(".buttonFormAction"), !this.updated);
        }

    }

    performConstrains() {


        // TransportAssignmentDate < FirstRegistrationDate
        let TransportAssignmentDate = document.querySelector('[data-fld-name="TransportAssignmentDate"] input');
        let FirstRegistrationDate = this.getValue("FirstRegistrationDate", "date");
        if (TransportAssignmentDate && FirstRegistrationDate) {
            TransportAssignmentDate.setAttribute("min", this.getFormattedDate(FirstRegistrationDate));
        }

        // ActualASPArrivalDate >= TransportAssignmentDate
        let ActualASPArrivalDate = document.querySelector('[data-fld-name="ActualASPArrivalDate"] input');
        if (TransportAssignmentDate && ActualASPArrivalDate) {
            ActualASPArrivalDate.setAttribute("min", this.getFormattedDate(this.getValue("TransportAssignmentDate", "date")));
        }

        // BlackBoxInstallationDate >= ActualASPArrivalDate
        let BlackBoxInstallationDate = document.querySelector('[data-fld-name="BlackBoxInstallationDate"] input');
        if (ActualASPArrivalDate && BlackBoxInstallationDate) {
            BlackBoxInstallationDate.setAttribute("min", this.getFormattedDate(this.getValue("ActualASPArrivalDate", "date")));
        }

        // NewPreparationDate >= ActualASPArrivalDate
        let NewPreparationDate = document.querySelector('[data-fld-name="NewPreparationDate"] input');
        if (ActualASPArrivalDate && NewPreparationDate) {
            NewPreparationDate.setAttribute("min", this.getFormattedDate(this.getValue("ActualASPArrivalDate", "date")));
        }


        // ActualWinterTiresInstallDate >= ActualASPArrivalDate
        let ActualWinterTiresInstallDate = document.querySelector('[data-fld-name="ActualWinterTiresInstallDate"] input');
        if (ActualASPArrivalDate && ActualWinterTiresInstallDate) {
            ActualWinterTiresInstallDate.setAttribute("min", this.getFormattedDate(this.getValue("ActualASPArrivalDate", "date")));
        }

        // NewDamageRepairEndDate >= ActualASPArrivalDate
        let NewDamageRepairEndDate = document.querySelector('[data-fld-name="NewDamageRepairEndDate"] input');
        if (ActualASPArrivalDate && NewDamageRepairEndDate) {
            NewDamageRepairEndDate.setAttribute("min", this.getFormattedDate(this.getValue("ActualASPArrivalDate", "date")));
        }

        // ActualReadyForCustomerDate >= ActualASPArrivalDate
        let ActualReadyForCustomerDate = document.querySelector('[data-fld-name="ActualReadyForCustomerDate"] input');
        if (ActualReadyForCustomerDate) {
            ActualReadyForCustomerDate.setAttribute("min", this.getFormattedDate(this.getValue("ActualASPArrivalDate", "date")));
        }

    }

    performInitialCalculations() {
        this.calculateTransportAssignmentDate();
        this.handleDeliveryConfirmedChange();
        this.calculateWinterTiresType();
        this.calculateTransportDamageDetected();
        //this.calculateDamageRepairDelayed();
        this.calculatePreparationDelayed();
        // calcolo gg di ritardo
        this.calculatePreparationDelayDays();
        this.calculateWinterTiresDelayDays();
        this.calculateDamageRepairDelayDays();

        // totale gg di ritardo
        this.calculateTotalAccumulatedDelay();

    }

    initEventHandlers() {
        this.initTransportHandlers();
        this.initASPHandlers();
        this.initDeliveryInfoHandlers();
    }


    // #region Transport Handlers

    initTransportHandlers() {
        // Fornitore
        //$('[data-fld-name="Dealer"] input').on('change', (e) => this.handleDealerChange(e));

        // Disponibile al ritiro
        //$('#isReadyForPickupSelect').on('change', (e) => this.handleIsReadyForPickupChange(e));

        // Consegna su isole
        $('#isOnIslandSelect').on('change', (e) => this.handleIsOnIslandChange(e));

        // Data incarico trasporto
        $('[data-fld-name="TransportAssignmentDate"] input').on('change', (e) => this.handleTransportAssignmentDateChange(e));

        // Trasportatore
        $('#transporterSelect').on('change', (e) => this.handleTransporterChange(e));

        // Data prevista arrivo su ASP
        $('[data-fld-name="ExpectedASPDeliveryDate"] input').on('change', (e) => this.handleExpectedASPDeliveryDateChange(e));

        // Ritardo trasporto
        $('#transportDelayedSelect').on('change', (e) => this.handleTransportDelayed(e));

        // ASP telefono
        //$('[data-fld-name="ASPDeliveryPhone"] input').on('change', (e) => this.handleASPDeliveryPhoneChange(e));

        // ASP
        //$('[data-fld-name="ASPDelivery"] input').on('change', (e) => this.handleASPDeliveryChange(e));
    }


    handleIsOnIslandChange() {
        this.calculateExpectedASPDeliveryDate();
    }

    handleTransportAssignmentDateChange() {
        this.calculateTransportAssignmentDate();
        this.performConstrains();
    }


    handleTransporterChange() {
        this.calculateExpectedASPDeliveryDate();
    }

    handleExpectedASPDeliveryDateChange() {
        this.calculateActualASPArrivalDate();
    }

    handleTransportDelayed() {
        this.calculateActualASPArrivalDate();
    }


    // #endregion Transport Handlers


    // #region ASP Handlers

    initASPHandlers() {
        this.initPreparationHandlers();
        this.initTiresHandlers();
        this.initDamageHandlers();
    }

    initPreparationHandlers() {
        // Data conferma arrivo su ASP
        $('[data-fld-name="ActualASPArrivalDate"] input').on('change', (e) => this.handleActualASPArrivalDateChange(e));


        // Conferma consegna
        $('#deliveryConfirmedSelect').on('change', (e) => this.handleDeliveryConfirmedChange(e));


        // Tipologia BB
        //$('[data-fld-name="SatelliteSystem"] input').on('change', (e) => this.handleSatelliteSystemChange(e));

        // Data previsto montaggio BB
        $('[data-fld-name="BlackBoxInstallationDate"] input').on('change', (e) => this.handleBlackBoxInstallationDateChange(e));


        // Conferma montaggio BB
        //$('#blackboxInstallationConfirmedSelect').on('change', (e) => this.handleBlackBoxInstallationConfirmedChange(e));

        // Ritardo Approntamento
        $('#preparationDelayedSelect').on('change', (e) => this.handlePreparationDelayedChange(e));

        // Nuova Data Approntamento
        $('[data-fld-name="NewPreparationDate"] input').on('change', (e) => this.handleNewPreparationDateChange(e));


        // Ritardo gg trasporto
        $('[data-fld-name="TransportDelayDays"] input').on('change', (e) => this.handleTransportDelayDaysChange(e));

        // Data prevista fine approntamento
        //$('[data-fld-name="ExpectedInstallationDate"] input').on('change', (e) => this.handleExpectedInstallationDateChange(e));


        // Ritardo gg approntamento
        $('[data-fld-name="PreparationDelayDays"] input').on('change', (e) => this.handlePreparationDelayDaysChange(e));
    }

    initTiresHandlers() {
        // Previste winter
        //$('#winterTiresTypeSelect').on('change', (e) => this.handleWinterTiresTypeChange(e));

        // Montaggio winter
        $('#winterTiresInstallNeededSelect').on('change', (e) => this.handleWinterTiresInstallNeededChange(e));


        // Ritardo Montaggio
        $('#winterTiresInstallDelayedSelect').on('change', (e) => this.handleWinterTiresInstallDelayedChange(e));


        // Nuova data fine montaggio
        $('[data-fld-name="ActualWinterTiresInstallDate"] input').on('change', (e) => this.handleActualWinterTiresInstallDateChange(e));


        // Motivazione ritardo
        $('#winterTiresDelayReasonSelect').on('change', (e) => this.handleWinterTiresDelayReasonChange(e));


        // Data prevista montaggio winter
        /*        $('[data-fld-name="ExpectedWinterTiresInstallDate"] input').on('change', (e) => this.handleExpectedWinterTiresInstallDateChange(e));*/


        // GG ritardo montaggio Winter
        $('[data-fld-name="WinterTiresDelayDays"] input').on('change', (e) => this.handleWinterTiresDelayDaysChange(e));
    }

    initDamageHandlers() {
        // Danni da trasporto / anomalie
        $('#transportDamageDetectedSelect').on('change', (e) => this.handleTransportDamageDetectedChange(e));

        // Ritardo riparazione danni
        $('#damageRepairDelayedSelected').on('change', (e) => this.handleDamageRepairDelayedChange(e));


        // Nuova data riparazione danni
        $('[data-fld-name="NewDamageRepairEndDate"] input').on('change', (e) => this.handleNewDamageRepairEndDateChange(e));


        // Ritardo gg riparazione danni
        $('[data-fld-name="DamageRepairDelayDays"] input').on('change', (e) => this.handleDamageRepairDelayDaysChange(e));

        // Data prevista riparazioni danni
        //$('[data-fld-name="ExpectedDamageRepairDate"] input').on('change', (e) => this.handleExpectedDamageRepairDateChange(e));


        // Motivazione ritardo
        $('#damageRepairDelayReasonSelect').on('change', (e) => this.handleDamageRepairDelayReasonChange(e));
    }

    handleTransportDamageDetectedChange() {
        let value = this.getValue("transportDamageDetectedSelect", "select");
        if (value == "true") {
            this.calculateExpectedDamageRepairDate();
        }
        else if (value == "false") {
            this.setFieldEmpty("ExpectedDamageRepairDate", "date");
        }

        this.calculateTransportDamageDetected();
    }

    handleWinterTiresDelayReasonChange() {
        let value = this.getValue("winterTiresDelayReasonSelect", "select");
        if (value != null) {
            this.setFieldError("WinterTiresDelayReason", "");
        }
        // un po brutto ma non trovo un altra soluzione
        this.updated = true;
        PageCommon.disable($(".buttonFormAction"), false);
    }

    handleDamageRepairDelayReasonChange() {

        let value = this.getValue("damageRepairDelayReasonSelect", "select");
        if (value != null) {
            this.setFieldError("DamageRepairDelayReason", "");
        }

        // un po brutto ma non trovo un altra soluzione
        this.updated = true;
        PageCommon.disable($(".buttonFormAction"), false);
    }


    handleDamageRepairDelayDaysChange() {
        this.updateDelayBorderColor("DamageRepairDelayDays");
        this.calculateTotalAccumulatedDelay();
    }

    handleNewDamageRepairEndDateChange() {
        this.calculateNewDamageRepairEndDate();

    }

    handleDamageRepairDelayedChange() {
        this.calculateDamageRepairDelayed();
    }


    handleWinterTiresDelayDaysChange() {
        this.updateDelayBorderColor("WinterTiresDelayDays");
        this.calculateTotalAccumulatedDelay();
    }


    handleActualWinterTiresInstallDateChange() {
        this.calculateActualWinterTiresInstallDate();
        // un po brutto ma non trovo un altra soluzione
        this.updated = true;
        PageCommon.disable($(".buttonFormAction"), false);
    }

    handleWinterTiresInstallDelayedChange() {
        this.calculateWinterTiresInstallDelayed();
        // un po brutto ma non trovo un altra soluzione
        this.updated = true; 
        PageCommon.disable($(".buttonFormAction"), false);
    }


    handleWinterTiresInstallNeededChange() {
        this.calculateWinterTiresInstallNeeded();
        this.calculateExpectedWinterTiresInstallDate();
    }


    handlePreparationDelayDaysChange() {
        this.updateDelayBorderColor("PreparationDelayDays");
        this.calculateTotalAccumulatedDelay();
    }

    handleTransportDelayDaysChange() {
        this.updateDelayBorderColor("TransportDelayDays");
        this.calculateTotalAccumulatedDelay();
    }

    handleNewPreparationDateChange() {
        this.calculateNewPreparationDate();
    }

    handlePreparationDelayedChange() {
        this.calculatePreparationDelayed();
    }

    calculateBlackBoxInstallationDate() {
        let BlackBoxInstallationDate = this.getValue("BlackBoxInstallationDate", "date");
        let ActualASPArrivalDate = this.getValue("ActualASPArrivalDate", "date");

        if (BlackBoxInstallationDate && ActualASPArrivalDate && BlackBoxInstallationDate < ActualASPArrivalDate) {
            this.setFieldError("BlackBoxInstallationDate", "DATA NON VALIDA");
        }
        else {
            this.setFieldError("BlackBoxInstallationDate", "");
        }
    }

    calculateNewPreparationDate() {
        let NewPreparationDate = this.getValue("NewPreparationDate", "date");
        let ActualASPArrivalDate = this.getValue("ActualASPArrivalDate", "date");

        if (NewPreparationDate && ActualASPArrivalDate && NewPreparationDate < ActualASPArrivalDate) {
            this.setFieldError("NewPreparationDate", "DATA NON VALIDA");
        }
        else {
            this.setFieldError("NewPreparationDate", "");
        }

        this.calculatePreparationDelayDays();
    }

    calculatePreparationDelayed() {
        let value = this.getValue("preparationDelayedSelect", "select");
        if (value == "true") {
            this.setFieldReadOnly("NewPreparationDate", false, false);
        }
        else {
            this.setFieldReadOnlyAndEmpty("NewPreparationDate", true, false);
        }
    }


    handleBlackBoxInstallationDateChange() {
        this.calculateBlackBoxInstallationDate();
    }

    handleDeliveryConfirmedChange() {

        let value = this.getValue("deliveryConfirmedSelect", "select");



        if (value == "false") {
                this.setTransportFieldsReadOnly(false);
                this.setASPFields(false);
        }
        else if (value == "true") {
            this.setTransportFieldsReadOnly(true);
            this.setASPFields(true);
            this.calculateExpectedInstallationDate();
            this.calculateExpectedDamageRepairDate();
            this.calculateTransportDelayDays();
            this.calculateWinterTiresType();
            this.performConstrains();
            
        }

    }

    handleActualASPArrivalDateChange() {

        let value = this.getValue("ActualASPArrivalDate", "date"); 

        let TransportAssignmentDateValue = this.getValue("TransportAssignmentDate", "date");
        if (value && TransportAssignmentDateValue && value < TransportAssignmentDateValue) {
            this.setFieldError("ActualASPArrivalDate", "DATA NON VALIDA");
        }
        else {
            this.setFieldError("ActualASPArrivalDate", "");
        }

        if (value) {
            this.calculateDeliveryConfirmed();
            this.setFieldReadOnly("DeliveryConfirmed", false, true);
        }
        else {
            this.setFieldReadOnly("DeliveryConfirmed", true, true);
        }

    }



    // #endregion ASP Handlers


    // #region Delivery Info Handlers
    initDeliveryInfoHandlers() {
        // Pronta ASP
        $('[data-fld-name="ActualReadyForCustomerDate"] input').on('change', (e) => this.handleActualReadyForCustomerDateChange(e));

        // Mad inviata
        //$('[data-fld-name="MADSentDate"] input').on('change', (e) => this.handleMADSentDateChange(e));

        // Ritardo gg accumulato complessivo su intero processo
        // TotalAccumulatedDelay
        $('[data-fld-name="TotalAccumulatedDelay"] input').on('change', (e) => this.handleTotalAccumulatedDelayChange(e));
    }

    handleTotalAccumulatedDelayChange() {
        this.updateDelayBorderColor("TotalAccumulatedDelay");
    }
    handleActualReadyForCustomerDateChange() {

        let ActualReadyForCustomerDate = this.getValue("ActualReadyForCustomerDate", "date");
        let ActualASPArrivalDate = this.getValue("ActualASPArrivalDate", "date");
        if (ActualReadyForCustomerDate && ActualASPArrivalDate && ActualReadyForCustomerDate < ActualASPArrivalDate) {
            this.setFieldError("ActualReadyForCustomerDate", "DATA NON VALIDA");
        }
        else {
            this.setFieldError("ActualReadyForCustomerDate", "");
        }

    }


    // #endregion Delivery Info Handlers


    // TotalAccumulatedDelay = PreparationDelayDays + TransportDelayDays + WinterTiresDelayDays + DamageRepairDelayDays
    calculateTotalAccumulatedDelay() {
        let PreparationDelayDays = this.getValue("PreparationDelayDays", "numeric") || 0;
        let TransportDelayDays = this.getValue("TransportDelayDays", "numeric") || 0;
        let WinterTiresDelayDays = this.getValue("WinterTiresDelayDays", "numeric") || 0;
        let DamageRepairDelayDays = this.getValue("DamageRepairDelayDays", "numeric") || 0;
        let TotalAccumulatedDelay = document.querySelector('[data-fld-name="TotalAccumulatedDelay"] input');
        TotalAccumulatedDelay.value = PreparationDelayDays + TransportDelayDays + WinterTiresDelayDays + DamageRepairDelayDays;
        $(TotalAccumulatedDelay).trigger('change');
    }

    // ExpectedInstallationDate = ActualASPArrivalDate + InstallationDays
    calculateExpectedInstallationDate() {
        let ActualASPArrivalDate = this.getValue("ActualASPArrivalDate", "date");
        let slaInstallation = parseInt(TheProviders.app_settings.find(x => x.Label == "Delivery.SlaExpectedInstallationDays")?.Mapping) ?? this.DEFAULT_SLA_INSTALLATION;
        if (ActualASPArrivalDate) {
            // parto da giorno dopo ActualASPArrivalDate
            let calculatedDate = new Date(ActualASPArrivalDate);
            let daysAdded = 0;
            while (daysAdded <= slaInstallation) {
                calculatedDate.setDate(calculatedDate.getDate() + 1); 
                const dayOfWeek = calculatedDate.getDay();
                if (dayOfWeek !== 0 && dayOfWeek !== 6) { // DOmenica = 0, Sabato = 6
                    daysAdded++;
                }
            }

            const formattedDate = this.getFormattedDate(calculatedDate);

            let ExpectedInstallationDate = document.querySelector('[data-fld-name="ExpectedInstallationDate"] input');
            ExpectedInstallationDate.value = formattedDate;
            $(ExpectedInstallationDate).trigger('change');
        }
    }

    // ExpectedASPDeliveryDate = TransportAssignmentDate + SlaIsola/SlaPenisola
    calculateExpectedASPDeliveryDate() {
        let ExpectedASPDeliveryDate = document.querySelector('[data-fld-name="ExpectedASPDeliveryDate"] input');

        let transportAssignmentDate = this.getValue("TransportAssignmentDate", "date");
        let transporter = this.getValue("transporterSelect", "select");
        let IsOnIsland = this.getValue("isOnIslandSelect", "select");

        // Se non ho Data incarico trasporto e Trasportatore
        if (!transportAssignmentDate || !transporter) {
            this.setFieldEmpty("ExpectedASPDeliveryDate", "text");
            return;
        }
        let slaIsola = transporter.SlaIsola ?? parseInt(TheProviders.app_settings.find(x => x.Label == "Delivery.SlaIsola")?.Mapping) ?? this.DEFAULT_SLA_ISOLA;
        let slaPenisola = transporter.SlaPenisola ?? parseInt(TheProviders.app_settings.find(x => x.Label == "Delivery.SlaPenisola")?.Mapping) ?? this.DEFAULT_SLA_PENISOLA;

        let calculatedDate = IsOnIsland === "true"
            ? this.addBusinessDays(transportAssignmentDate, slaIsola)
            : this.addBusinessDays(transportAssignmentDate, slaPenisola);


        const formattedDate = this.getFormattedDate(calculatedDate);
        ExpectedASPDeliveryDate.value = formattedDate;
        $(ExpectedASPDeliveryDate).trigger('change');

        this.calculateActualASPArrivalDate();
    }

    // ActualASPArrivalDate = ExpectedASPDeliveryDate (if TransportDelayed == false)
    calculateActualASPArrivalDate() {
        var deliveryConfirmed = this.getValue("deliveryConfirmedSelect", "select");
        if (deliveryConfirmed == "false") {
            let ActualASPArrivalDate = document.querySelector('[data-fld-name="ActualASPArrivalDate"] input');
            let ExpectedASPDeliveryDate = this.getValue("ExpectedASPDeliveryDate", "date");
            let TransportDelayed = this.getValue("transportDelayedSelect", "select");
            if (ExpectedASPDeliveryDate && TransportDelayed != "true") {
                const formattedDate = this.getFormattedDate(ExpectedASPDeliveryDate);
                ActualASPArrivalDate.value = formattedDate;
                $(ActualASPArrivalDate).trigger('change');

                this.setFieldReadOnly("ActualASPArrivalDate", false, false);
            }
            else if (!ExpectedASPDeliveryDate) {
                this.setFieldReadOnly("ActualASPArrivalDate", true, false);
            }
        }

        this.calculateDeliveryConfirmed();
    }

    calculateDeliveryConfirmed() {
        let ActualASPArrivalDate = this.getValue("ActualASPArrivalDate", "date");
        let hasError = this.hasError("ActualASPArrivalDate");

        if (ActualASPArrivalDate && !hasError) {
            this.setFieldReadOnly("DeliveryConfirmed", false, true);
        }
        else {
            this.setFieldReadOnlyAndEmpty("DeliveryConfirmed", true, true);
        }

    }

    calculatePreparationDelayDays() {
        let PreparationDelayDays = document.querySelector('[data-fld-name="PreparationDelayDays"] input');
        let ExpectedInstallationDate = this.getValue("ExpectedInstallationDate", "date");
        let NewPreparationDate = this.getValue("NewPreparationDate", "date");
        if (ExpectedInstallationDate && NewPreparationDate) {
            let delayDays = Math.ceil((NewPreparationDate - ExpectedInstallationDate) / (1000 * 60 * 60 * 24));
            PreparationDelayDays.value = delayDays;
            $(PreparationDelayDays).trigger('change');
        } else {
            PreparationDelayDays.value = 0;
            $(PreparationDelayDays).trigger('change');
        }
    }

    calculateTransportDelayDays() {
        let TransportDelayDays = document.querySelector('[data-fld-name="TransportDelayDays"] input');
        let ExpectedASPDeliveryDate = this.getValue("ExpectedASPDeliveryDate", "date");
        let ActualASPArrivalDate = this.getValue("ActualASPArrivalDate", "date");
        if (ExpectedASPDeliveryDate && ActualASPArrivalDate) {
            let delayDays = Math.ceil((ActualASPArrivalDate - ExpectedASPDeliveryDate) / (1000 * 60 * 60 * 24));
            TransportDelayDays.value = delayDays;
            $(TransportDelayDays).trigger('change');
        } else {
            TransportDelayDays.value = 0;
            $(TransportDelayDays).trigger('change');
        }
    }

    // ExpectedWinterTiresInstall = ActualASPArrivalDate + InstallationDays
    calculateExpectedWinterTiresInstallDate() {
        let ActualASPArrivalDate = this.getValue("ActualASPArrivalDate", "date");
        let slaInstallation = parseInt(TheProviders.app_settings.find(x => x.Label == "Delivery.SlaExpectedInstallationDays")?.Mapping) ?? this.DEFAULT_SLA_INSTALLATION;
        let WinterTiresInstallNeeded = this.getValue("winterTiresInstallNeededSelect", "select");

        if (ActualASPArrivalDate && WinterTiresInstallNeeded == "true") {
            const calculatedDate = this.addDays(ActualASPArrivalDate, slaInstallation);
            const formattedDate = this.getFormattedDate(calculatedDate);

            let ExpectedWinterTiresInstallDate = document.querySelector('[data-fld-name="ExpectedWinterTiresInstallDate"] input');
            ExpectedWinterTiresInstallDate.value = formattedDate;
            $(ExpectedWinterTiresInstallDate).trigger('change');
        }
        else {
            this.setFieldEmpty("ExpectedWinterTiresInstallDate", "text");
        }
    }

    calculateActualWinterTiresInstallDate() {
        let ActualWinterTiresInstallDate = this.getValue("ActualWinterTiresInstallDate", "date");
        let ActualASPArrivalDate = this.getValue("ActualASPArrivalDate", "date");
        if (ActualWinterTiresInstallDate && ActualASPArrivalDate && ActualWinterTiresInstallDate < ActualASPArrivalDate) {
            this.setFieldError("ActualWinterTiresInstallDate", "DATA NON VALIDA");
        }
        else {
            this.setFieldError("ActualWinterTiresInstallDate", "");
        }
         this.calculateWinterTiresDelayDays();
    }

    calculateWinterTiresDelayDays() {
        let WinterTiresDelayDays = document.querySelector('[data-fld-name="WinterTiresDelayDays"] input');
        let ExpectedWinterTiresInstallDate = this.getValue("ExpectedWinterTiresInstallDate", "date");
        let ActualWinterTiresInstallDate = this.getValue("ActualWinterTiresInstallDate", "date");
        if (ExpectedWinterTiresInstallDate && ActualWinterTiresInstallDate) {
            let delayDays = Math.ceil((ActualWinterTiresInstallDate - ExpectedWinterTiresInstallDate) / (1000 * 60 * 60 * 24));
            WinterTiresDelayDays.value = delayDays;
            $(WinterTiresDelayDays).trigger('change');
        } else {
            WinterTiresDelayDays.value = 0;
            $(WinterTiresDelayDays).trigger('change');
        }
    }

    calculateWinterTiresType() {
        let value = this.getValue("winterTiresTypeSelect", "select");
        let deliveryConfirmed = this.getValue("deliveryConfirmedSelect", "select");

        if (value == "false") {
            this.setFieldReadOnlyAndEmpty("WinterTiresInstallNeeded", true, true);
            this.setFieldReadOnlyAndEmpty("WinterTiresInstallDelayed", true, true);
            this.setFieldReadOnlyAndEmpty("ExpectedWinterTiresInstallDate", true, false);
            this.setFieldReadOnlyAndEmpty("ActualWinterTiresInstallDate", true, false);
            this.setFieldReadOnlyAndEmpty("WinterTiresDelayReason", true, true);
        }
        else if (value == "true" && deliveryConfirmed == "true") {
            this.setFieldReadOnly("WinterTiresInstallNeeded", false, true);
        }
        this.calculateWinterTiresInstallNeeded();

    }

    calculateWinterTiresInstallNeeded() {
        let value = this.getValue("winterTiresInstallNeededSelect", "select");
        if (value == "true") {
            this.setFieldReadOnly("WinterTiresInstallDelayed", false, true);
        }
        else if (value == "false") {
            this.setFieldReadOnlyAndEmpty("WinterTiresInstallDelayed", true, true);
        }
        this.calculateWinterTiresInstallDelayed();
    }

    calculateWinterTiresInstallDelayed() {

        let value = this.getValue("winterTiresInstallDelayedSelect", "select");
        if (value == "true") {
            this.setFieldReadOnly("ActualWinterTiresInstallDate", false, true);
            this.setFieldReadOnly("WinterTiresDelayReason", false, true);
        }
        else if (value == "false") {
            this.setFieldReadOnlyAndEmpty("ActualWinterTiresInstallDate", true, false);
            this.setFieldReadOnlyAndEmpty("WinterTiresDelayReason", true, true);
            this.setFieldEmpty("WinterTiresDelayDays", "numeric");
        }
        this.calculateExpectedWinterTiresInstallDate();

    }
    calculateDamageRepairDelayed() {
        let value = this.getValue("damageRepairDelayedSelected", "select");
        if (value == "true") {
            this.setFieldReadOnly("NewDamageRepairEndDate", false, false);
            this.setFieldReadOnly("DamageRepairDelayReason", false, true);
        }
        else if (value == "false") {
            this.setFieldReadOnlyAndEmpty("NewDamageRepairEndDate", true, false);
            this.setFieldReadOnlyAndEmpty("DamageRepairDelayReason", true, true);
            this.setFieldEmpty("DamageRepairDelayDays", "numeric");
        }

    }

    // ExpectedInstallationDate = ActualASPArrivalDate + InstallationDays
    calculateExpectedDamageRepairDate() {
        let ActualASPArrivalDate = this.getValue("ActualASPArrivalDate", "date");
        let slaRepair = parseInt(TheProviders.app_settings.find(x => x.Label == "Delivery.SlaDamageRepairDays")?.Mapping) ?? this.DEFAULT_SLA_REPAIR;
        let TransportDamageDetected = this.getValue("transportDamageDetectedSelect", "select");

        if (ActualASPArrivalDate && TransportDamageDetected == "true") {
            const calculatedDate = this.addDays(ActualASPArrivalDate, slaRepair);
            const formattedDate = this.getFormattedDate(calculatedDate);


            let ExpectedDamageRepairDate = document.querySelector('[data-fld-name="ExpectedDamageRepairDate"] input');
            ExpectedDamageRepairDate.value = formattedDate;
            $(ExpectedDamageRepairDate).trigger('change');
        }
    }

    calculateTransportDamageDetected() {
        let value = this.getValue("transportDamageDetectedSelect", "select");
        let deliveryConfirmed = this.getValue("deliveryConfirmedSelect", "select");

        if (value == "false") {
            this.setFieldReadOnlyAndEmpty("DamageRepairDelayed", true, true);
            this.setFieldReadOnlyAndEmpty("NewDamageRepairEndDate", true, true);
            this.setFieldReadOnlyAndEmpty("ExpectedDamageRepairDate", true, false);
            this.setFieldReadOnlyAndEmpty("DamageRepairDelayReason", true, true);
        }
        else if (value == "true" && deliveryConfirmed == "true") {
            this.setFieldReadOnly("DamageRepairDelayed", false, true);
        }
        this.calculateDamageRepairDelayed();
    }


    calculateNewDamageRepairEndDate() {

        let NewDamageRepairEndDate = this.getValue("NewDamageRepairEndDate", "date");
        let ActualASPArrivalDate = this.getValue("ActualASPArrivalDate", "date");
        if (NewDamageRepairEndDate && ActualASPArrivalDate && NewDamageRepairEndDate < ActualASPArrivalDate) {
            this.setFieldError("NewDamageRepairEndDate", "DATA NON VALIDA");
        }
        else {
            this.setFieldError("NewDamageRepairEndDate", "");
            this.calculateDamageRepairDelayDays();
        }
    }

    calculateDamageRepairDelayDays() {
        let DamageRepairDelayDays = document.querySelector('[data-fld-name="DamageRepairDelayDays"] input');
        let ExpectedDamageRepairDate = this.getValue("ExpectedDamageRepairDate", "date");
        let NewDamageRepairEndDate = this.getValue("NewDamageRepairEndDate", "date");
        if (ExpectedDamageRepairDate && NewDamageRepairEndDate) {
            let delayDays = Math.ceil((NewDamageRepairEndDate - ExpectedDamageRepairDate) / (1000 * 60 * 60 * 24));
            DamageRepairDelayDays.value = delayDays;
            $(DamageRepairDelayDays).trigger('change');
        } else {
            DamageRepairDelayDays.value = 0;
            $(DamageRepairDelayDays).trigger('change');
        }
    }

    calculateTransportAssignmentDate() {

        let transportAssignmentDate = this.getValue("TransportAssignmentDate", "date");
        let firstRegistrationDate = this.getValue("FirstRegistrationDate", "date");

        if (!transportAssignmentDate) {
            this.setFieldReadOnly("ActualASPArrivalDate", true, false);
        }

        if (transportAssignmentDate && firstRegistrationDate && transportAssignmentDate < firstRegistrationDate) {
            this.setFieldError("TransportAssignmentDate", "DATA NON VALIDA");
        }
        else {
            this.setFieldError("TransportAssignmentDate", "");
            this.calculateExpectedASPDeliveryDate();
        }

        this.calculateActualASPArrivalDate();
    }

    onFormSaveHandler(verb, rs) {
        super.onFormSaveHandler(verb, rs);
        if (rs != null) {
            if (rs.Errors && rs.Errors.length > 0 && rs.Success != true) {
                rs.Errors.forEach(error => {
                    this.setFieldError(error.Field, error.Message);
                });
            } else {
                this.fieldErrors.clear();
                this.updated = false;
                this.updateFormButtonState();
                PageCommon.disable($(".buttonFormAction"), true);
                if (rs?.Data?.MADSentDate == null) {
                    this.setFieldEmpty("MADSentDate", "date");
                }
                if (rs?.Data?.CycleTime) {
                    this.setFieldEmpty("CycleTime", "numeric");
                }

            }
        }
    }

    // #region Utility Functions
    updateDelayBorderColor(fieldName) {
        let inputGroup = document.querySelector(`[data-fld-name="${fieldName}"] .input-group`);
        let delayDays = this.getValue(fieldName, "numeric");
        if (inputGroup) {
            if (delayDays === null || delayDays === "" || delayDays == 0) {
                inputGroup.style.border = "0.5px solid transparent";
            }
            else if (delayDays > 0) {
                inputGroup.style.border = "0.5px solid red";
            }
            else {
                inputGroup.style.border = "0.5px solid green";
            }
        }
    }


    getFormattedDate(date) {
        if (!date) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }


    setFieldReadOnlyAndEmpty(fieldName, isReadOnly, isSelect = false) {
        this.setFieldReadOnly(fieldName, isReadOnly, isSelect);
        if (isReadOnly) {
            this.setFieldEmpty(fieldName, isSelect ? "select" : "text");
        }
    }

    setFieldEmpty(fieldName, fieldType = "text") {
        if (fieldType == "select") {
            let div = document.querySelector(`[data-fld-name="${fieldName}"]`);
            let singleInput = {
                sinput: div,
                type: "select",
                provider: div.getAttribute("data-fld-provider"),
            };
            let select = this.getInput(singleInput);

            if (select) {
                if (singleInput.provider == "_c_lookup_true_false") {
                    select.val("false");
                }
                else {
                    select.val("");
                }
                select.trigger("change");
            }
        }
        else {
            let input = document.querySelector(`[data-fld-name="${fieldName}"] input`);
            if (fieldType == "numeric") {
                input.value = "0";
            }
            else {
                input.value = "";
            }
            $(input).trigger('change');
        }


    }


    getSingleInputValue(row, bValidate, singleInput) {
        const result = super.getSingleInputValue(row, bValidate, singleInput);

        if (bValidate) {
            let fieldName = singleInput.sinput.attr("data-fld-name");

            if (!result) {
                this.setFieldError(fieldName, "CAMPO OBBLIGATORIO");
            } else {
                this.setFieldError(fieldName, "");
            }
        }

        return result;
    }


    setFieldError(fieldName, errorMessage) {
        const singleInput = this.getSingleInputByName(fieldName);
        if (!singleInput) return;

        const error = jQuery(".js-error-txt", singleInput.sinput);
        const hasError = !!(errorMessage && errorMessage.trim());
        const hadError = this.fieldErrors.has(fieldName);

        const input = document.querySelector(`[data-fld-name="${fieldName}"] input`);
        const select = document.querySelector(`[data-fld-name="${fieldName}"] select`);
        const accordionParent = input?.closest('.block-accordion') ?? select?.closest('.block-accordion');

        if (hasError) {
            if (!hadError) {
                this.fieldErrors.add(fieldName);
            }

            error.text(errorMessage);
            singleInput.sinput.addClass("has-error");
            jQuery(".js-error-txt", singleInput.sinput).css("opacity", 1);

            if (accordionParent) {
                accordionParent.classList.add('accordion-error');
                accordionParent.classList.add('is-open');
                accordionParent.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

        } else {
            if (hadError) {
                this.fieldErrors.delete(fieldName);
            }

            error.text("");
            singleInput.sinput.removeClass("has-error");
            jQuery(".js-error-txt", singleInput.sinput).css("opacity", 0);

            if (accordionParent) {
                const fieldsWithErrorsInAccordion = accordionParent.querySelectorAll('.has-error');
                if (fieldsWithErrorsInAccordion.length === 0) {
                    accordionParent.classList.remove('accordion-error');
                }
            }
        }

        this.updateFormButtonState();
    }

    updateFormButtonState() {
        const hasErrors = this.fieldErrors.size > 0;
        PageCommon.disable($(".buttonFormAction"), hasErrors);
    }


    setFieldReadOnly(fieldName, isReadOnly, isSelect) {
        let div = document.querySelector(`[data-fld-name="${fieldName}"]`);

        let singleInput = {
            sinput: div,
            provider: div.getAttribute("data-fld-provider"),
        };
        if (isSelect) {
            singleInput.type = "select";
        }
        this.customSetReadOnly(singleInput, isReadOnly);
    }

    customSetReadOnly(singleInput, lFlag) {
        let iset = $(singleInput.sinput);
        if (lFlag) {
            iset.addClass("read-only");
            $("input", iset).attr("disabled", true);
            $("textarea", iset).attr("disabled", true);
            $('input[type="button"]', iset).addClass("disabled");
            // Select2
            if (!Pqp.isNullOrEmpty(singleInput.provider)) {
                let select = this.getInput(singleInput);
                select.prop("disabled", true);
            }
        } else {
            iset.removeClass("read-only");
            $("input", iset).attr("disabled", false);
            $("textarea", iset).attr("disabled", false);
            $('input[type="button"]', iset).removeClass("disabled");
            // Select2
            if (!Pqp.isNullOrEmpty(singleInput.provider)) {
                let select = this.getInput(singleInput);
                select.prop("disabled", false);
            }
        }
    }

    getValue(fieldName, type) {
        let res = null;
        if (type == "select") {
            let input = document.getElementById(fieldName);
            if (input) {
                res = input.value;
                return res;
            } else {
                return null;
            }
            return res
        }
        else if (type == "date") {
            let input = document.querySelector(`[data-fld-name="${fieldName}"] input`);
            if (input) {
                res = new Date(input.value);
                if (isNaN(res.getTime())) {
                    return null;
                }
                return res;
            } else {
                return null;
            }
        }
        else if (type == "numeric") {
            let input = document.querySelector(`[data-fld-name="${fieldName}"] input`);
            if (input) {
                res = parseInt(input.value);
                return isNaN(res) ? null : res;
            } else {
                return null;
            }
        }
    }

    setASPFields(deliveryConfirmed) {

        if (deliveryConfirmed == false) {


            let ActualASPArrivalDate = this.getValue("ActualASPArrivalDate", "date");

            if (ActualASPArrivalDate) {
                this.setFieldReadOnly("ActualASPArrivalDate", false, true);

            }



            this.setFieldEmpty("ExpectedInstallationDate", "text");
            this.setFieldEmpty("TransportDelayDays", "numeric");

            this.setFieldReadOnly("BlackBoxInstallationDate", true, false);
            this.setFieldReadOnly("BlackBoxInstallationConfirmed", true, true);

            this.setFieldReadOnly("PreparationDelayed", true, true);
            this.setFieldEmpty("PreparationDelayed", "select");
            this.setFieldEmpty("PreparationDelayDays", "numeric");

            this.setFieldReadOnly("NewPreparationDate", true, false);

            this.setFieldReadOnly("WinterTiresType", true, true);

            this.setFieldReadOnly("WinterTiresInstallNeeded", true, true);
            this.setFieldEmpty("WinterTiresInstallNeeded", "select");

            this.setFieldReadOnly("WinterTiresInstallDelayed", true, true);
            this.setFieldEmpty("WinterTiresInstallDelayed", "select");

            this.setFieldReadOnly("ExpectedWinterTiresInstallDate", true, false);
            this.setFieldEmpty("ExpectedWinterTiresInstallDate", "text");

            this.setFieldReadOnly("ActualWinterTiresInstallDate", true, false);
            this.setFieldReadOnly("WinterTiresDelayReason", true, true);

            this.setFieldReadOnly("TransportDamageDetected", true, true);
            this.setFieldEmpty("TransportDamageDetected", "select");

            this.setFieldReadOnly("DamageRepairDelayed", true, true);
            this.setFieldEmpty("DamageRepairDelayed", "select");


            this.setFieldReadOnly("NewDamageRepairEndDate", true, false);

            this.setFieldReadOnly("ExpectedDamageRepairDate", true, false);
            this.setFieldEmpty("ExpectedDamageRepairDate", "text");

            this.setFieldReadOnly("DamageRepairDelayReason", true, true);
            this.setFieldEmpty("DamageRepairDelayReason", "select");
        }
        else if (deliveryConfirmed == true) {
            this.setFieldReadOnly("ActualASPArrivalDate", true, true);

            this.setFieldReadOnly("BlackBoxInstallationDate", false, false);
            this.setFieldReadOnly("BlackBoxInstallationConfirmed", false, true);
            this.setFieldReadOnly("PreparationDelayed", false, true);

            this.setFieldReadOnly("TransportDamageDetected", false, true);
        }

    }



    setTransportFieldsReadOnly(isReadOnly) {
        this.setFieldReadOnly("IsReadyForPickup", isReadOnly, true);
        this.setFieldReadOnly("IsOnIsland", isReadOnly, true);
        this.setFieldReadOnly("TransportAssignmentDate", isReadOnly, false);
        this.setFieldReadOnly("TransporterUid", isReadOnly, true);
        //this.setFieldReadOnly("ExpectedASPDeliveryDate", isReadOnly, false);
        this.setFieldReadOnly("TransportDelayed", isReadOnly, true);
    }

    hasError(fieldName) {
        let singleInput = this.getSingleInputByName(fieldName);
        return singleInput.sinput.hasClass("has-error");
    }

    addDays(date, days) {
        const result = new Date(date.getTime());
        result.setUTCDate(result.getUTCDate() + days);
        return result;
    }

    addBusinessDays(date, daysToAdd) {
        const result = new Date(date);
        let daysAdded = 0;

        const italianHolidays = [
            "1-1",  // 1 gennaio
            "6-1",  // 6 gennaio (Epifania)
            "25-4", // 25 aprile (Festa della Liberazione)
            "1-5",  // 1 maggio (Festa del Lavoro)
            "2-6",  // 2 giugno (Festa della Repubblica)
            "15-8", // 15 agosto (Ferragosto)
            "1-11", // 1 novembre (Tutti i Santi)
            "8-12", // 8 dicembre (Immacolata Concezione)
            "25-12", // 25 dicembre (Natale)
            "26-12"  // 26 dicembre (Santo Stefano)
        ];

        function isHoliday(date) {
            const day = date.getDate();
            const month = date.getMonth() + 1;
            return italianHolidays.includes(`${day}-${month}`);
        }

        while (daysAdded < daysToAdd) {
            result.setDate(result.getDate() + 1);

            const dayOfWeek = result.getDay();

            if (dayOfWeek !== 0 && dayOfWeek !== 6 && !isHoliday(result)) {
                daysAdded++;
            }
        }

        return result;
    }

    // #endregion Utility Functions

}

